import axios from '@/libs/http'

/**
 * 获取订单列表
 */
export const getOrderList = (pageNo, pageSize , types, status) => {
  let data = new URLSearchParams()
  data.append("pageNo", pageNo)
  data.append("pageSize", pageSize)
  data.append("types", types)
  data.append("status", status)
  return axios.request({
    url: '/s/c/order/list',
    data,
    method: 'post'
  })
}

/**
 * 获取订单详情
 */
export const getOrder = (id) => {
  return axios.request({
    url: '/s/c/order/get',
    params: {
      id
    },
    method: 'get'
  })
}

/**
 * 确认订单
 */
export const confirmOrder = (id) => {
  return axios.request({
    url: '/s/c/order/confirm',
    params: {
      id
    },
    method: 'post'
  })
}

/**
 * 取消订单
 */
export const cancelOrder = (id,reason,fileList,refundPath) => {
  let data = new URLSearchParams()
  data.append("id", id)
  if(reason){
    data.append("reason", reason)
  }
  if(fileList){
    data.append('fileList', fileList)
  }
  data.append('refundPath',refundPath)

  return axios.request({
    url: '/s/c/order/cancelV2',
    data,
    method: 'post'
  })
}

/**
 * 开始服务
 */
export const startService = (id) => {
  return axios.request({
    url: '/s/c/order/startService',
    params: {
      id
    },
    method: 'post'
  })
}


/**
 * 获取订单列表
 */
export const getRewardLogList = (pageNo, pageSize) => {
  return axios.request({
    url: '/s/c/order/listRewardLog',
    params: {
      pageNo,
      pageSize
    },
    method: 'get'
  })
}

/**
 * 店员订单反馈提交
 */
export const comment = ({orderId, content, photoUrls} = {}) => {
  let data = new URLSearchParams()
  data.append("orderId", orderId)
  data.append("content", content)
  data.append('photoUrls', photoUrls)

  return axios.request({
    url: '/s/c/orderFeedBack/add',
    data,
    method: 'post'
  })
}

/**
 * 我的业绩
 */
export const statisticsClerkOrder = (startTime, endTime) => {
  let data = new URLSearchParams()
  data.append('startTime',startTime)
  data.append('endTime',endTime)
  return axios.request({
    url: '/s/c/statistics/statisticsClerkOrder',
    data,
    method: 'post'
  })
}



/**
 * 店员提醒用户续单
 */
export const remindContinued = (id) => {
  let data = new URLSearchParams()
  data.append("id", id)
  return axios.request({
    url: '/s/c/orderContinuedRemind/remind',
    data,
    method: 'post'
  })
}

/**
 * 通知用户微信号有问题
 */
export const noticeUserUpdateWechatId = (id, noticeType) => {
  return axios.request({
    url: '/s/c/order/noticeUserUpdateWechatId',
    params: {
      id,
      noticeType
    },
    method: 'get'
  })
}

export const updateNoticeCount = (orderNo) => {
  return axios.request({
    url: '/s/c/order/updateNoticeCount',
    params: {
      orderNo
    },
    method: 'get'
  })
}

/**
 * 获取订单的打赏特效
 */
export const getOrderRewardEffect = (id)=>{
  return axios.request({
    url: '/s/c/order/getOrderRewardEffect',
    params:{
      id
    },
    method: 'get'
  })
}
/**
 * 查询订单是否有过首续单转换记录
 */
export const isFcChangeFlag = (orderId)=>{
  let data = new URLSearchParams()
  data.append("orderId", orderId)
  return axios.request({
    url: '/s/c/order/continuedApply/isFcChangeFlag',
    data,
    method: 'post'
  })
}
